enum PERIMETER_MODE {
  INCREASED_MODE = 'increased-mode',
  DECREASED_MODE = 'decreased-mode',
}

export default PERIMETER_MODE
